import { Flex, Link, Text, Center, Heading, Stack, Button } from '@chakra-ui/react';
import React from 'react';
import Image from 'next/image';
import NextLink from 'next/link';
import { MdImage } from 'react-icons/md';
import Avatar from './Avatar';
import { ExtendedTrip } from '@/types/extended';

interface Props {
	canDelete?: boolean;
	handleRemove?: () => void;
	data: ExtendedTrip;
}

export default function Trip({ data, canDelete, handleRemove }: Props): JSX.Element {
	const coverPhoto = data.photos?.[0]?.url || data.housing?.photos?.[0]?.url;

	return (
		<Flex w='100%' borderRadius='12px' p='3' bg='white' pos='relative' direction={{ base: 'column', md: 'row' }}>
			<Center
				pos='relative'
				bg='charcoal.50'
				h='40'
				overflow='hidden'
				borderRadius='12px'
				w={{ base: 'full', md: '64' }}
				mr={{ base: '0', md: '9' }}>
				<MdImage size={24} color='#a9bdc7' />
				{coverPhoto && (
					<Image layout='fill' objectFit='cover' src={coverPhoto as string} alt={`Photo of ${data.name}`} />
				)}
				<Flex
					border='1px'
					py='1'
					px='2'
					w='max-content'
					borderRadius='full'
					borderColor={coverPhoto ? 'clay.100' : 'transparent'}
					bg={coverPhoto ? 'rgba(0,0,0,.25)' : 'charcoal.100'}
					backdropFilter='blur(2px)'
					pos='absolute'
					right='3'
					bottom='3'>
					<Text color={coverPhoto ? 'clay.100' : 'charcoal.800'} fontSize='xs'>
						{data.date}
					</Text>
				</Flex>
			</Center>
			<Stack mt={{ base: 3, md: 0 }} spacing={4} w='full'>
				<Flex justifyContent='start' alignItems='center'>
					<Avatar img={data.author?.image} name={data.author?.name} size={24} />

					<Text ml='2' w='full' fontSize='sm'>
						Published by{' '}
						<Text as='span' fontWeight='bold'>
							{data.author?.name}
						</Text>
					</Text>
				</Flex>
				<Flex
					w='full'
					alignItems='center'
					justifyContent='space-between'
					flexDir={{ base: 'column', md: 'row' }}>
					<Flex w='full' pos='relative' flexGrow={1} alignItems='center'>
						<Stack spacing={{ base: 2, md: 3 }}>
							<Heading as='h2' fontWeight='medium' fontSize='2xl'>
								{data.name}
							</Heading>
							{!data.ttd.length ? (
								<Text color='#525456' fontSize='lg'>
									No reccomendations yet
								</Text>
							) : (
								<Text color='#525456' fontSize='lg'>
									{data.ttd?.length} Recommendation
									{data.ttd?.length > 1 ? 's' : ''}
								</Text>
							)}
						</Stack>
					</Flex>
					<Center w={{ base: 'full', md: 'fit-content' }} mt={{ base: 2, md: 0 }} ml={{ base: 0, md: 8 }}>
						{canDelete ? (
							<Button
								as='button'
								textAlign='center'
								px='16'
								py='4'
								h='max-content'
								w='full'
								cursor='pointer'
								borderRadius='full'
								border='1px'
								bg='red.100'
								borderColor='red.600'
								color='red.600'
								transition='all .2s'
								mt={{ base: '3', md: '0' }}
								_hover={{}}
								_active={{}}
								onClick={() => handleRemove?.()}>
								REMOVE
							</Button>
						) : (
							<NextLink href={`/t/${data.id}`} passHref>
								<Link
									textAlign='center'
									px='16'
									py='4'
									h='max-content'
									w='full'
									cursor='pointer'
									borderRadius='full'
									border='1px'
									borderColor='black'
									transition='all .2s'
									mt={{ base: '3', md: '0' }}
									_hover={{ bg: 'black', color: 'clay.100' }}>
									VIEW
								</Link>
							</NextLink>
						)}
					</Center>
				</Flex>
			</Stack>
		</Flex>
	);
}
